import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import { Card, ModalTypesEnum } from '../components/Kanban/interfaces/kanban'
import { ReservaCentralizadaDetalleIdModal } from '../components/ReservaDetalleModal/interfaces/ReservaCentralizadaDetalleModal'
import { ReservaCentralizadaDetalleModal } from '../interfaces/ReservaCentralizadaDetalleModal'

interface DetalleReservaModalState {
  isOpenReservaDetalleModal: boolean
  cardsDetail: Card[]
  isOpenComentarioReservaDetalleModal: boolean
  reservaDetalleModal: ReservaCentralizadaDetalleModal | null
  reservaDetalleUpdate: boolean
  updatedItems: ReservaCentralizadaDetalleIdModal[]
  lastUpdateTimestamp: number | null
  showConfirmationElement?: boolean
  estadoFisicoTemp?: ModalTypesEnum | null
  isNecessaryUpdateDetails?: boolean
}

const initialState: DetalleReservaModalState = {
  isOpenReservaDetalleModal: false,
  cardsDetail: [],
  isOpenComentarioReservaDetalleModal: false,
  reservaDetalleModal: null,
  reservaDetalleUpdate: false,
  updatedItems: [],
  lastUpdateTimestamp: null,
  estadoFisicoTemp: null,
}

const detalleReservaModalSlice = createSlice({
  name: 'detalleReservaModal',
  initialState,
  reducers: {
    setIsOpenReservaDetalleModal(
      state,
      action: PayloadAction<{
        value: boolean
        estadoFisicoTemp?: ModalTypesEnum
      }>,
    ) {
      state.isOpenReservaDetalleModal = action.payload.value
      state.estadoFisicoTemp = action.payload.estadoFisicoTemp
    },
    setCardsDetailReservaDetalleModal(
      state,
      action: PayloadAction<{ value: Card[] }>,
    ) {
      state.cardsDetail = action.payload.value
    },
    setIsOpenComentarioReservaDetalleModal(
      state,
      action: PayloadAction<{ value: boolean }>,
    ) {
      state.isOpenComentarioReservaDetalleModal = action.payload.value
    },
    setReservaDetalleModal(
      state,
      action: PayloadAction<{
        value: ReservaCentralizadaDetalleModal | null
      }>,
    ) {
      state.reservaDetalleModal = action.payload.value
    },
    setReservaDetalleUpdate(
      state,
      action: PayloadAction<{
        value: boolean
        items?: ReservaCentralizadaDetalleIdModal[]
      }>,
    ) {
      state.reservaDetalleUpdate = action.payload.value

      if (action.payload.items) {
        state.updatedItems = action.payload.items
        state.lastUpdateTimestamp = Date.now()
      }
    },
    setShowConfirmationElement(
      state,
      action: PayloadAction<{ value?: boolean }>,
    ) {
      state.showConfirmationElement = action.payload.value
    },
    setIsNecessaryUpdateDetails(
      state,
      action: PayloadAction<{ value?: boolean }>,
    ) {
      state.isNecessaryUpdateDetails = action.payload.value
    },
  },
})

export const {
  setIsOpenReservaDetalleModal,
  setCardsDetailReservaDetalleModal,
  setIsOpenComentarioReservaDetalleModal,
  setReservaDetalleModal,
  setReservaDetalleUpdate,
  setShowConfirmationElement,
  setIsNecessaryUpdateDetails,
} = detalleReservaModalSlice.actions

const DetalleReservaModalReducer = detalleReservaModalSlice.reducer

export default DetalleReservaModalReducer
